import { Component, Output, EventEmitter, Input } from '@angular/core';
import { IUserRole } from '@account-users/user/models/UserRole';

@Component({
  selector: 'app-edit-account-roles',
  templateUrl: './edit-account-roles.component.html',
  styleUrls: ['./edit-account-roles.component.scss'],
})
export class EditAccountRolesComponent {
  @Input() allAccountUserRoles: IUserRole[] = [];
  @Input() accountUserTypeRoles: string[] = [];
  @Input() isUpdatingAccountRole = false;

  @Output() updateAccountRoles = new EventEmitter();

  constructor() {}

  hasRole(role: string) {
    return this.accountUserTypeRoles.includes(role);
  }

  onUpdateAccountRoles(role, e) {
    this.updateAccountRoles.emit({ role, e });
  }
}
